import { useProgress } from '@react-three/drei'
import { useEffect, useState } from 'react'
import './style.css'
import useGame from './stores/useGame.js'

export default function EnterUI({ onEnter }) {
  const [canEnter, setCanEnter] = useState(false)
  const [isExiting, setIsExiting] = useState(false)
  const { progress, loaded } = useProgress()
 
  useEffect(() => {
    if (progress >= 100 && loaded > 0) {
      const t = setTimeout(() => setCanEnter(true), 100)
      return () => clearTimeout(t)
    }
  }, [progress, loaded])

  const handleEnter = () => {
    setIsExiting(true) // trigger fade-out animation
    setTimeout(() => {
      document.body.style.backgroundColor = 'black'
      document.getElementById('root').style.backgroundColor = 'black'
      useGame.getState().setStartBgMusic(true)
      onEnter()
    }, 800) // match fade-out duration
  }

  return (
    <div className={`enter-ui ${isExiting ? 'fade-out' : ''}`}>
      <div className="bg-image" />
      <h1>Welcome to my home(page)</h1>
      <p className="kuvaus">
        This is my experimental portfolio site.<br></br><br></br> Use the location buttons to explore and click on the objects for more information. <br></br>If you want to get straight to the point try{' '}
        <a
          href="https://roosaemiliaronkainen.com/index"
          target="_blank"
          rel="noopener noreferrer"
        >
          this
        </a>{' '}
         instead.<br></br><br></br><br></br>
      </p>

      <div className="enter-container">
        {!canEnter ? (
          <p>{Math.floor(progress)}</p>
        ) : (
          <button
            className={`enter-button ${canEnter ? 'visible' : ''}`}
            onClick={handleEnter}
          >
            Enter
          </button>
        )}
      </div>
    </div>
  )
}
